// extracted by mini-css-extract-plugin
export default {"root":"CoursePausePendingRequestsTableHeader_root__mYhTn","heading":"CoursePausePendingRequestsTableHeader_heading__F-x6J"};